module.exports = __webpack_public_path__ + "static/media/search.03bb87e7.svg";